import { FC } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { KioskLayout } from '../components';
import { KioskFormsListing } from './components/kiosk-listing';
import { KioskFormsContextProps, KioskFormsWrapper } from './provider';

export const KioskForms: FC<KioskFormsContextProps> = (props) => {
  const navigate = useNavigate();

  const handleSelect = (idKey: 'formId' | 'packetId', idValue: string) => {
    // TODO: clear patron Info in zustand store

    if (props.patronType) {
      navigate({ to: `/kiosk/${props.patronType}-patron/${props.locationId}`, search: { [idKey]: idValue } });
      return;
    }

    // TODO: validate this compare to `/form?${type}=${token}&companyId=${companyId}&kiosk=${companyId}&ni=yes`
    navigate({
      to: '/form',
      replace: true,
      search: { kiosk: props.locationId, [idKey]: idValue },
    });
  };

  return (
    <KioskFormsWrapper {...props}>
      <KioskLayout locationId={props.locationId}>
        <KioskFormsListing locationId={props.locationId} onSelect={handleSelect} />
      </KioskLayout>
    </KioskFormsWrapper>
  );
};
